// src/components/Role/RoleList.jsx
import React, { useState, useEffect } from 'react';
import { getRoles, deleteRole } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Space, Popconfirm, message } from 'antd';

const RoleList = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await getRoles();
      setRoles(response.data);
    } catch (error) {
      message.error('Failed to fetch roles');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteRole(id);
      message.success('Role deleted successfully');
      fetchRoles();
    } catch (error) {
      message.error('Failed to delete role');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'roleId', key: 'roleId' },
    { title: 'Role Name', dataIndex: 'roleName', key: 'roleName' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => navigate(`/roles/edit/${record.roleId}`)}>Edit</Button>
          <Popconfirm
            title="Are you sure to delete this role?"
            onConfirm={() => handleDelete(record.roleId)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Button type="primary" onClick={() => navigate('/roles/add')} style={{ marginBottom: 16 }}>
        Add Role
      </Button>
      <Table
        columns={columns}
        dataSource={roles}
        loading={loading}
        rowKey="roleId"
      />
    </div>
  );
};

export default RoleList;
